import $ from 'jquery';

angular.module("SupportAgent")
.controller(
 'TabDeviceController',
 ['$rootScope', '$scope', '$filter', 'EventHandler', '$timeout',
  'INTERACT',
 function ($rootScope,$scope,$filter,EventHandler,$timeout, INTERACT) {
  var TEST_BATTERY_CAPACITY = 82;
  var TEST_BATTERY_TEMPERATURE = 83;
  var TEST_CPU_LOAD = 72;
  var TEST_RAM = 74;
  var TEST_INTERNAL_MEMORY = 75;
  var TEST_EXTERNAL_MEMORY = 76;
  var TEST_NETWORK_OPERATOR = 124;
  var TEST_NETWORK_TECHNOLOGY = 79;
  var TEST_WIFI_SSID = 11;
  var TEST_WIFI_SIGNAL = 71;
  var TEST_STORAGE = 142;
  var testDates = [];
  $scope.lastTestDate = "";
  $scope.showProgress = false;
  $scope.showResult = true;
  $scope.externalMemory = "";
  $scope.internalMemory = "";
  $scope.getLatestTestResult = function(tid,results) {
   var index = results.indexOf($filter('filter')(results, {tid: tid}, true)[0]);
   if (index==-1) return "";
   testDates.push(new Date(results[index].ts));
   return results[index].trd;
  };
  $scope.getLatestTestResultComment = function(tid,results) {
   var index = results.indexOf($filter('filter')(results, {tid: tid}, true)[0]);
   if (index==-1) return "";
   testDates.push(new Date(results[index].ts));
   return results[index].tc;
  };
  function getValueFromResult(res, entry) {
   if(!res) return "";
   res = JSON.parse(res);
   return (res.hasOwnProperty(entry) && String(res[entry]))||"";
  }
  function getpercentage(avail, total) {
   return ((avail/total) *100).toFixed(1);
  }
  $rootScope.getSpace = function(bytes) {
   var s=0;
   if(bytes>(1048576)) {
    s = (bytes/(1048576)).toFixed(2)+"MB";
    if(bytes>(1073741824)) {
     s = (bytes/(1073741824)).toFixed(2)+"GB";
    }
   }
   return s;
  };
  $scope.$on('updateDeviceTabData', function (event, results) {
   $scope.lastTestDate = "";
   testDates = [];
   var ram_avail = getValueFromResult($scope.getLatestTestResult(TEST_RAM, results),"ram_avail");
   if(!ram_avail) ram_avail = getValueFromResult($scope.getLatestTestResult(TEST_RAM, results),"a");
   if(ram_avail) {
    $rootScope.deviceInfo.battery.capacity =
     getValueFromResult($scope.getLatestTestResult(TEST_BATTERY_CAPACITY, results),"battery_level");
    if(!$rootScope.deviceInfo.battery.capacity)
     $rootScope.deviceInfo.battery.capacity =
      getValueFromResult($scope.getLatestTestResult(TEST_BATTERY_CAPACITY, results),"l");
    $rootScope.deviceInfo.battery.temperature =
     getValueFromResult($scope.getLatestTestResult(TEST_BATTERY_TEMPERATURE, results),"battery_temp");
    if(!$rootScope.deviceInfo.battery.temperature)
     $rootScope.deviceInfo.battery.temperature =
      getValueFromResult($scope.getLatestTestResult(TEST_BATTERY_TEMPERATURE, results),"t");
    $rootScope.deviceInfo.battery.capacity+="%";
    var capacity = parseInt($rootScope.deviceInfo.battery.capacity, 10);
    var temperature = parseInt($rootScope.deviceInfo.battery.temperature,10); 
    if (capacity <= 20 || temperature >= 40) $("#batteryProg").addClass("progress-bar progress-bar-danger");
    else if (capacity > 20 && capacity < 40) $("#batteryProg").addClass("progress-bar progress-bar-warning");
    else if (capacity > 40) $("#batteryProg").addClass("progress-bar progress-bar-success");
    $rootScope.deviceInfo.usage.cpu =
     getValueFromResult($scope.getLatestTestResult(TEST_CPU_LOAD, results),"cpu_usage");
    if(!$rootScope.deviceInfo.usage.cpu)
     $rootScope.deviceInfo.usage.cpu =
      getValueFromResult($scope.getLatestTestResult(TEST_CPU_LOAD, results),"cpu");
    $rootScope.deviceInfo.usage.cpu = Math.round($rootScope.deviceInfo.usage.cpu * 100) / 100;
    if($rootScope.deviceInfo.usage.cpu) {
     var cpuProg = parseInt($rootScope.deviceInfo.usage.cpu, 10);
     if (cpuProg >= 90) $("#cpuProg").addClass("progress-bar progress-bar-danger");
     else if (cpuProg >= 50 && cpuProg < 90) $("#cpuProg").addClass("progress-bar progress-bar-warning");
     else if (cpuProg < 50) $("#cpuProg").addClass("progress-bar progress-bar-success");
     $rootScope.deviceInfo.usage.cpu+="%";
    }
    else $rootScope.deviceInfo.usage.cpu = "N/A";
    var total_ram = getValueFromResult($scope.getLatestTestResult(TEST_RAM, results),"ram_total");
    if(!total_ram) total_ram = getValueFromResult($scope.getLatestTestResult(TEST_RAM, results),"t");
    $rootScope.deviceInfo.usage.ram = "";
    if(total_ram) {
     $rootScope.deviceInfo.usage.ram = 100-parseInt(getpercentage(ram_avail,total_ram),10);
     var ramProg = $rootScope.deviceInfo.usage.ram;
     if (ramProg >= 90) $("#ramProg").addClass("progress-bar progress-bar-danger");
     else if (ramProg >= 50 && ramProg < 90) $("#ramProg").addClass("progress-bar progress-bar-warning");
     else if (ramProg < 50) $("#ramProg").addClass("progress-bar progress-bar-success");
     $rootScope.deviceInfo.usage.ram+="%";
    }
    else $rootScope.deviceInfo.usage.ram = "N/A";
    var int_mem_avail = getValueFromResult($scope.getLatestTestResult(TEST_STORAGE, results),"int_mem_avail");
    var int_mem_total = getValueFromResult($scope.getLatestTestResult(TEST_STORAGE, results),"int_mem_total");
    $rootScope.deviceInfo.memory.internal.spaceinPercentage = "";
    var r;
    if(int_mem_total) {
     r = Math.round(100 - getpercentage(int_mem_avail, int_mem_total)); //used space in percentage
     $rootScope.deviceInfo.memory.internal.spaceinPercentage = r?(r+"%"):"N/A";
     $scope.internalMemory =
      $rootScope.deviceInfo.memory.internal.spaceinPercentage?
      ($rootScope.getSpace(int_mem_avail) + " / " + $rootScope.getSpace(int_mem_total) + " Free"):
      "";
     var im = parseInt(r, 10);
     $scope.applyMemProgClr(im,"imProg");
    }
    var ext_mem_avail = getValueFromResult($scope.getLatestTestResult(TEST_STORAGE, results),"ext_mem_avail");
    var ext_mem_total = getValueFromResult($scope.getLatestTestResult(TEST_STORAGE, results),"ext_mem_total");
    $rootScope.deviceInfo.memory.external.spaceinPercentage = "";
    if(ext_mem_total) {
     if(ext_mem_total=="0") {
      $scope.showProgress = true;
      $scope.showResult = false;
      $scope.externalMemory = "";
     }
     else {
      $scope.showProgress = false;
      $scope.showResult = true;
      r = Math.round(100 - getpercentage(ext_mem_avail, ext_mem_total)); // used space in percentage
      $rootScope.deviceInfo.memory.external.spaceinPercentage = r?(r+"%"):"N/A";
      $scope.externalMemory = $rootScope.deviceInfo.memory.external.spaceinPercentage?
       ($rootScope.getSpace(ext_mem_avail) + " / " + $rootScope.getSpace(ext_mem_total) + " Free"):
       "";
      var em = parseInt(r, 10);
      $scope.applyMemProgClr(em,"emProg");
     }
    }
    $rootScope.deviceInfo.mobile.operator =
     getValueFromResult($scope.getLatestTestResult(TEST_NETWORK_OPERATOR, results),"network_operator");
    if(!$rootScope.deviceInfo.mobile.operator)
     $rootScope.deviceInfo.mobile.operator =
      getValueFromResult($scope.getLatestTestResult(TEST_NETWORK_OPERATOR, results),"n");
    if(!$rootScope.deviceInfo.mobile.operator) $rootScope.deviceInfo.mobile.operator = "N/A";
    $rootScope.deviceInfo.mobile.technology =
     getValueFromResult($scope.getLatestTestResult(TEST_NETWORK_TECHNOLOGY, results),"network_tech");
    if(!$rootScope.deviceInfo.mobile.technology) $rootScope.deviceInfo.mobile.technology = "N/A";
    $rootScope.deviceInfo.wifi.ssid =
     getValueFromResult($scope.getLatestTestResult(TEST_WIFI_SSID, results),"ssid");
    if(!$rootScope.deviceInfo.wifi.ssid) $rootScope.deviceInfo.wifi.ssid = "N/A";
    $rootScope.deviceInfo.wifi.signal =
     getValueFromResult($scope.getLatestTestResult(TEST_WIFI_SIGNAL, results),"signal");
    if(!$rootScope.deviceInfo.wifi.signal)
     $rootScope.deviceInfo.wifi.signal =
      getValueFromResult($scope.getLatestTestResult(TEST_WIFI_SIGNAL, results),"s");
    if(!$rootScope.deviceInfo.wifi.signal) $rootScope.deviceInfo.wifi.signal = "N/A";
    else $rootScope.deviceInfo.wifi.signal+=" dbm";
   }
   else $scope.fallbackParsing(results);
   if(testDates.length > 0) {
    testDates.sort(date_sort_desc);
    if (testDates[0]) $scope.lastTestDate = $rootScope.ISO8601DateFormat(testDates[0]);
   }
  });
  $scope.refreshData = function () {
   var account = INTERACT.get_account($rootScope.accountID);
   if($rootScope.isHidden("deviceinfotest")||!account.dcid) return;
   EventHandler.APILAYER.sendMessage({
    convid: +account.dcid,
    channelid: INTERACT.D.xaction.channel.diagreq,
    msg: $rootScope.testPayload.deviceInfo,
    devid: +account.d[account.sd].id
   });
   $rootScope.appendMessageToHistory({
    convid: $rootScope.conversationID, acid: $rootScope.accountID,
    display_name: "",
    msg: $rootScope.strings.str_diagnostic_request+$rootScope.strings.str_device_info,
    msgtime: new Date(),
    channelid: 3, // TODO: magic
    convstatus: 1 // TODO: magic
   });
  };
  var date_sort_desc = function (date1, date2) {
   // This is a comparison function that will result in dates being sorted in
   // DESCENDING order.
   if (date1 > date2) return 1;
   if (date1 < date2) return -1;
   return 0;
  };
  $scope.launchTest = function (testName) {
   var convid = $rootScope.selected_conversation.id;
   var account = $rootScope.selected_account;
   var seldevid = account.d[account.sd].id; // selected device id
   if($rootScope.isTestRequestPending(122,seldevid)) {
    $("#remote-screenshot").modal();
    return ;
   }
   EventHandler.APILAYER.sendMessage({
    convid: convid,
    channelid: INTERACT.D.xaction.channel.diagreq,
    msg: "3|7", // TODO: magic
    devid: seldevid
   });
   $rootScope.appendMessageToHistory({
    convid: convid, acid: account.id,
    msg: $rootScope.strings.str_diagnostic_request+$rootScope.getString(testName),
    msgtime: new Date(),
    channelid: INTERACT.D.xaction.channel.diagreq
   });
   // TODO: I wish I knew why launching a test should necessarily involve this:
   $rootScope.SecurityTests.push({
    acid:account.id, did:seldevid, tid:122,
    time:new Date()
   });
  };
  $scope.$on('onUpdateScreenshotImageGallery', function (event,images,did) {   
   $scope.screenshotArray = []; // TODO: it should be a map or reduce assignment
   for(var fid in images["didS"+did]) {
    var image = {"thumb":images["didS"+did][fid], "img":images["didS"+did][fid]};
    $scope.screenshotArray.push(image);
   }
  });
  function parseBattery_CPU(result) {
   return result ? result.substring(result.lastIndexOf(":") + 1, result.lastIndexOf("%") + 1) : "";
  }
  function parseBatterytemp(result) {
   return result ?result.substring(result.lastIndexOf(":") + 1, result.lastIndexOf(" ")) :"";
  }
  function parseRAM(result) {
   return result ? result.substring(result.lastIndexOf("%") - 4, result.lastIndexOf("%") + 1) : "";
  }
  function parseMemory(result) {
   return {
   "spaceinPercentage": 100 - parseInt(result.substring(result.lastIndexOf("%:") - 4, result.lastIndexOf("%:"))),
   "freeSpace": result.substring(result.lastIndexOf("%:") + 2, result.lastIndexOf("of")),
   "totalSpace": result.substring(result.lastIndexOf("of") + 2, result.lastIndexOf("free"))};
  }
  function parseNetworkSignal(result) {
   return result.substring(result.lastIndexOf(":") + 1, result.length);
  }
  $scope.fallbackParsing = function(results) {
   $rootScope.deviceInfo.battery.capacity = parseBattery_CPU($scope.getLatestTestResultComment(TEST_BATTERY_CAPACITY, results));
   $rootScope.deviceInfo.battery.temperature = parseBatterytemp($scope.getLatestTestResultComment(TEST_BATTERY_TEMPERATURE, results));
   if($rootScope.deviceInfo.battery.capacity) {
    var capacity = parseInt($rootScope.deviceInfo.battery.capacity, 10);
    var temperature = parseInt($rootScope.deviceInfo.battery.temperature,10);
    if(capacity <= 20 || temperature >= 40) $("#batteryProg").addClass("progress-bar progress-bar-danger");
    else if(capacity > 20 && capacity < 40) $("#batteryProg").addClass("progress-bar progress-bar-warning");
    else if(capacity > 40) $("#batteryProg").addClass("progress-bar progress-bar-success");
   } else $rootScope.deviceInfo.battery.capacity = "N/A";
   $rootScope.deviceInfo.usage.cpu = parseBattery_CPU($scope.getLatestTestResultComment(TEST_CPU_LOAD, results));
   if($rootScope.deviceInfo.usage.cpu) {
    var cpuProg = parseInt($rootScope.deviceInfo.usage.cpu, 10);
    if(cpuProg >= 90) $("#cpuProg").addClass("progress-bar progress-bar-danger");
    else if(cpuProg >= 50 && cpuProg < 90) $("#cpuProg").addClass("progress-bar progress-bar-warning");
    else if(cpuProg < 50) $("#cpuProg").addClass("progress-bar progress-bar-success");
   } else $rootScope.deviceInfo.usage.cpu = "N/A";

   $rootScope.deviceInfo.usage.ram = parseRAM($scope.getLatestTestResultComment(TEST_RAM, results));
   if($rootScope.deviceInfo.usage.ram.indexOf(":")!=-1) $rootScope.deviceInfo.usage.ram = $rootScope.deviceInfo.usage.ram.replace(":","");
   if($rootScope.deviceInfo.usage.ram) {
    var ramProg = 100-parseInt($rootScope.deviceInfo.usage.ram, 10);
    $rootScope.deviceInfo.usage.ram = ramProg+"%";
    if(ramProg >= 90) $("#ramProg").addClass("progress-bar progress-bar-danger");
    else if(ramProg >= 50 && ramProg < 90) $("#ramProg").addClass("progress-bar progress-bar-warning");
    else if(ramProg < 50) $("#ramProg").addClass("progress-bar progress-bar-success");
   } else $rootScope.deviceInfo.usage.ram = "N/A";

   var memoryResult = parseMemory($scope.getLatestTestResultComment(TEST_INTERNAL_MEMORY, results));
   $rootScope.deviceInfo.memory.internal.spaceinPercentage = memoryResult.spaceinPercentage?(memoryResult.spaceinPercentage + "%"):"N/A";
   $rootScope.deviceInfo.memory.internal.freeSpace = memoryResult.freeSpace;
   $rootScope.deviceInfo.memory.internal.totalSpace = memoryResult.totalSpace;
   $scope.internalMemory = memoryResult.spaceinPercentage?(memoryResult.freeSpace + "/" + memoryResult.totalSpace + "Free"):"";
   var im = parseInt(memoryResult.spaceinPercentage, 10);
   $scope.applyMemProgClr(im,"imProg");
   memoryResult = parseMemory($scope.getLatestTestResultComment(TEST_EXTERNAL_MEMORY, results));
   if(memoryResult.spaceinPercentage) {
    $scope.showProgress = false;
    $scope.showResult = true;
    $rootScope.deviceInfo.memory.external.spaceinPercentage = memoryResult.spaceinPercentage+"%";
    $rootScope.deviceInfo.memory.external.freeSpace = memoryResult.freeSpace;
    $rootScope.deviceInfo.memory.external.totalSpace = memoryResult.totalSpace;
    $scope.externalMemory =
     $rootScope.deviceInfo.memory.external.freeSpace + "/" +
     $rootScope.deviceInfo.memory.external.totalSpace + " Free";
    var em = parseInt(memoryResult.spaceinPercentage, 10);
    $scope.applyMemProgClr(em,"emProg");
   }
   else {
    $scope.showProgress = true;
    $scope.showResult = false;
    $scope.externalMemory = "";
   }
   $rootScope.deviceInfo.mobile.operator =
    parseNetworkSignal($scope.getLatestTestResultComment(TEST_NETWORK_OPERATOR, results))||"N/A";
   $rootScope.deviceInfo.mobile.technology =
    parseNetworkSignal($scope.getLatestTestResultComment(TEST_NETWORK_TECHNOLOGY, results))||"N/A";
   $rootScope.deviceInfo.wifi.ssid = $scope.getLatestTestResultComment(TEST_WIFI_SSID, results)||"N/A";
   $rootScope.deviceInfo.wifi.signal = $scope.getLatestTestResultComment(TEST_WIFI_SIGNAL, results)||"N/A";
  };
  $scope.applyMemProgClr = function(value,id) {
   if (value >= 90) $('#'+id).addClass("progress-bar progress-bar-danger");
   else if (value >= 50 && value < 90) $('#'+id).addClass("progress-bar progress-bar-warning");
   else if (value < 50) $('#'+id).addClass("progress-bar progress-bar-success");
  };
 }]);
/* vim:set ts=8 sw=1 expandtab: */
